import MMenu from './MMenu.vue';

MMenu.install = (app) => {
  app.component('MMenu', MMenu);
};

export { MMenu };
